'use client'
import {
  context_default
} from "./chunk-LMQE7T4N.mjs";

// src/context/root/useConfig.ts
import { useContext } from "react";
var useConfig = () => {
  const context = useContext(context_default);
  if (!context) {
    throw new Error("useConfig must be used within a ConfigProvider");
  }
  return context;
};
var useConfig_default = useConfig;

export {
  useConfig,
  useConfig_default
};
//# sourceMappingURL=chunk-UGF34K5Q.mjs.map